/**
 * Created by tigran on 18.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const DataTableIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <rect
        x={2}
        y={2}
        width={28}
        height={28}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
      <line
        x1={30}
        y1={10}
        x2={2}
        y2={10}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
      <line
        x1={6}
        y1={22}
        x2={14}
        y2={22}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
        data-color="color-2"
      />
      <line
        x1={18}
        y1={22}
        x2={26}
        y2={22}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
        data-color="color-2"
      />
      <line
        x1={6}
        y1={18}
        x2={14}
        y2={18}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
        data-color="color-2"
      />
      <line
        x1={18}
        y1={18}
        x2={26}
        y2={18}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
        data-color="color-2"
      />
      <line
        x1={6}
        y1={14}
        x2={14}
        y2={14}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
        data-color="color-2"
      />
      <line
        x1={18}
        y1={14}
        x2={26}
        y2={14}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
        data-color="color-2"
      />
      <line
        x1={6}
        y1={26}
        x2={14}
        y2={26}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
        data-color="color-2"
      />
      <line
        x1={18}
        y1={26}
        x2={26}
        y2={26}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
        data-color="color-2"
      />
      <line
        x1={6}
        y1={6}
        x2={14}
        y2={6}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
      <line
        x1={18}
        y1={6}
        x2={26}
        y2={6}
        fill="none"
        stroke={color}
        strokeLinecap="square"
        strokeMiterlimit={10}
        strokeWidth={2.4}
      />
    </svg>
  );
};
